import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "Benchmarking/Assets/logo.png";
import NavbarSearch from "Benchmarking/Components/NavbarSearch";
import { _nav } from "Benchmarking/Routes/navbarContent";
import "Benchmarking/Scss/Navbar.scss";

const Navbar = ({ entity, setEntity }) => {
  const navigate = useNavigate();
  const [searchDefault, setSearchDefault] = useState("");

  const onClick = (item) => {
    navigate(`/benchmarking/${item.to}`);
    setEntity(item.key);
  };

  useEffect(() => {
    const path = window.location.pathname.split("/")[2];
    const index_nav = _nav.findIndex((item) => item.key == path);
    setEntity(index_nav !== -1 ? _nav[index_nav].key : "");
    setSearchDefault(index_nav !== -1 ? _nav[index_nav].key : "all");
  }, [window.location.pathname]);

  const handleSearch = (e) => {
    navigate(
      `/benchmarking/search?entity=${searchDefault}&params=${e.target.value}`
    );
  };
  return (
    <div className="navbar-benchmarking">
      <div className="left">
        <img src={logo} alt="" />
        <div className="entities-nav">
          {_nav.map((item, index) => {
            return (
              <div
                key={index}
                className={`${entity == item.key ? "selected" : "item_menu"}`}
                onClick={() => onClick(item)}
              >
                <p>{item.label}</p>
              </div>
            );
          })}
        </div>
      </div>
      <div className="right">
        <NavbarSearch
          searchDefault={searchDefault}
          setSearchDefault={setSearchDefault}
        />
        <svg
          width="35"
          height="35"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginLeft: "10px", cursor: "pointer" }}
        >
          <path
            d="M18.5588 19.5488C17.5654 16.8918 15.0036 15 12 15C8.99638 15 6.4346 16.8918 5.44117 19.5488M18.5588 19.5488C20.6672 17.7154 22 15.0134 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 15.0134 3.33285 17.7154 5.44117 19.5488M18.5588 19.5488C16.8031 21.0756 14.5095 22 12 22C9.49052 22 7.19694 21.0756 5.44117 19.5488M15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z"
            stroke="#28303F"
            stroke-width="0.5"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default Navbar;
